<div class="driver-view-container" *ngIf="employeeView">
  <div class="trip-detail-popup-right">
    <img
      src="../../../assets/img/icons8-macos-close-60.png"
      class="close-icons"
      (click)="close()"
    />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Employee Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row m-0">
      <div class="col-sm-9">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Employee Name</div>
            <div class="dec">{{ S9Data.username }}</div>
          </div>
          <div class="col-sm-7">
            <div class="dec">
              {{ S9Data.mobile }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
            <div class="dec">
              {{ S9Data.email }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Employee ID</div>
            <div class="dec">{{ S9Data.adminRegisterDetails.employee_id }}</div>
          </div>
          <div class="col-sm-7">
            <div class="head">Joined In</div>
            <div class="dec"></div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Designation</div>
            <div class="dec">{{ S9Data.designation }}</div>
          </div>
          <div class="col-sm-7">
            <div class="head">Role</div>
            <div class="dec">{{ S9Data.role }}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="right-side">
          <img
            src="{{ S9Data.adminRegisterDetails.profile_pic }}"
            class="driverImg"
          />
          <div class="row mr-0 ml-0">
            <div class="col-sm-5 p-0">
              <div class="dec-head">Gender</div>
              <div class="dec-head">DOB</div>
            </div>
            <div class="col-sm-7 p-0">
              <div class="dec-right">
                {{ S9Data.adminRegisterDetails.gender }}
              </div>
              <div class="dec-right">
                {{ S9Data.adminRegisterDetails.dob | date : "yyyy/MM/dd" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-btn">
      <button (click)="editUsers()">Edit</button>
    </div>
  </div>
</div>

<!-- ---------------------- Edit user ------------------- -->

<div *ngIf="!employeeView" class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img
      src="../../../assets/img/icons8-macos-close-60.png"
      class="close-icons"
      (click)="close()"
    />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Employee Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <form class="admin-forms mt-3" [formGroup]="s9Form">
      <div class="row m-0 input-fileds-container">
        <div class="col-xl-9 col-lg-9 col-md-9 driver-truck">
          <div class="row mtb">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Employee</mat-label>
                  <input matInput formControlName="username" required />
                  <mat-error>Please enter name number</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Mobile</mat-label>
                  <input matInput formControlName="mobile" readonly required />
                  <mat-error>Please enter mobile number</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" readonly />
                  <!-- <mat-error>Please enter email</mat-error> -->
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Employee ID</mat-label>
                  <input matInput formControlName="employee_id" required />
                  <mat-error>Please enter user name</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row mb">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Joined In</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker1"
                    [max]="minDob"
                    formControlName="joined_in"
                    (change)="onDateChnage(2)"
                    required
                    ng-pattern="/^(?:1[8-9]|[2-5][0-9]|60)$/"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker1"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error> Date of birth is required</mat-error>
                  <mat-error *ngIf="invalidDob"
                    >Please select valid Date of birth</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Role</mat-label>
                  <input matInput required />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3">
          <div class="right-side image">
            <img src="{{ truckImage }}" class="driverImg" />
            <div class="image-upload-area">
              <p>Upload Truck Image</p>
              <span (click)="uploadImage.click()"
                ><img src="../../../assets/img/upload.svg" class="editImage"
              /></span>
              <input
                #uploadImage
                type="file"
                (change)="onChange($event)"
                hidden
              />
            </div>
          </div>
        </div>
      </div>
      <div class="fixed-btn">
        <button (click)="updateS9employee()">Save</button>
      </div>
    </form>
  </div>
</div>
